<template>
  <div class="Title">
    {{ productName }}
  </div>
</template>

<script>
export default {
  props: ["productName"],
};
</script>

<style lang="scss" scoped>
.Title {
  font-size: 24px;
  font-weight: 600;
  color: #0078d4;
  line-height: 33px;
}
</style>